export const HUNGRY = 'hungry'
export const ALONE = 'alone'
export const CUDDLESOME = 'cuddlesome'
export const SOCIABLE = 'sociable'

export const natures = [HUNGRY, ALONE, CUDDLESOME, SOCIABLE]

export function getNature() {
  return natures[Math.floor(Math.random() * natures.length)]
}